import {
  AssessmentTwoTone,
  Dashboard,
  FolderTwoTone,
  GavelTwoTone,
  HelpCenterOutlined,
  InsertDriveFileTwoTone,
  ManageAccounts,
  ManageAccountsOutlined,
  PeopleAltTwoTone,
  SettingsTwoTone,
  SummarizeOutlined,
} from "@mui/icons-material";
import ApprovalRoundedIcon from "@mui/icons-material/ApprovalRounded";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import DomainAddIcon from "@mui/icons-material/DomainAdd";
import GavelIcon from "@mui/icons-material/Gavel";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import HowToRegIcon from "@mui/icons-material/HowToReg";
import MonetizationOnIcon from "@mui/icons-material/MonetizationOn";
import PlaylistAddCheckOutlinedIcon from "@mui/icons-material/PlaylistAddCheckOutlined";
import type { ReactNode } from "react";

export interface MenuItem {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  items?: MenuItem[];
  name: string;
  tooltip?: string;
  roles?: any;
}
export interface GaItems {
  link?: string;
  icon?: ReactNode;
  badge?: string;
  badgeTooltip?: string;
  items?: MenuItem[];
  name: string;
}

export interface MenuItems {
  items: MenuItem[];
}
export interface GaMenuItems {
  items: MenuItem[];
}

export const menuItems: MenuItems[] = [
  {
    items: [
      {
        name: "",
        link: "/vendor/dashboard",
        icon: Dashboard,
        tooltip: "Dashboard",
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "",
        link: "vendor/users",
        icon: PeopleAltTwoTone,
        tooltip: "Users",
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "",
        link: "/vendor/proposal-list",
        icon: SummarizeOutlined,
        tooltip: "Proposals",
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "",
        link: "vendor/templates-bank-list",
        icon: FolderTwoTone,
        tooltip: "Templates Bank",
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "",
        link: "/vendor/analytics",
        icon: AssessmentTwoTone,
        tooltip: "Analytics",
        roles: ["vendor_user", "vendor_admin"],
      },
      {
        name: "",
        link: "/vendor/help-center",
        icon: HelpCenterOutlined,
        tooltip: "Help Centre",
        roles: ["vendor_user", "vendor_admin"],
      },
    ],
  },
];

export const tcsCorporateMenuItems: MenuItems[] = [
  {
    items: [
      {
        name: "",
        link: "/corporate/dashboard",
        icon: Dashboard,
        tooltip: "Dashboard",
        roles: ["system_admin", "t_user", "t_approver", "cpt_approver"],
      },
      {
        name: "",
        link: "/corporate/users",
        icon: PeopleAltTwoTone,
        tooltip: "Users",
        roles: ["system_admin", "t_user", "t_approver", "cpt_approver"],
      },
      {
        name: "",
        link: "/corporate/analytics",
        icon: AssessmentTwoTone,
        tooltip: "Analytics",
        roles: ["system_admin", "t_user", "t_approver", "cpt_approver"],
      },
      {
        name: "",
        link: "/corporate/services-review",
        icon: SettingsTwoTone,
        tooltip: "Services Review",
        roles: ["t_user", "system_admin"],
      },
      {
        name: "",
        link: "/corporate/cr/create/description",
        icon: InsertDriveFileTwoTone,
        tooltip: "Draft New Capacity Request",
        roles: ["system_admin", "t_user", "t_approver", "cpt_approver"],
      },
      {
        name: "",
        link: "/corporate/templates-bank-list",
        icon: FolderTwoTone,
        tooltip: "Templates Bank",
      },
      {
        name: "",
        link: "/corporate/crs-list",
        icon: PlaylistAddCheckOutlinedIcon,
        tooltip: "Capactiy Requests Repository",
        roles: ["system_admin", "t_user", "t_approver", "cpt_approver"],
      },
      {
        name: "",
        link: "/corporate/preferred-vendors",
        icon: GavelTwoTone,
        tooltip: "Preferred/Panel Vendors",
        roles: ["system_admin", "t_user"],
      },
      {
        name: "",
        link: "/corporate/vendor-management",
        icon: ManageAccountsOutlined,
        tooltip: "Vendor Management",
        roles: ["system_admin"],
      },
      {
        name: "",
        link: "/corporate/t-approver",
        icon: ApprovalRoundedIcon,
        tooltip: "D/MD Approver",
        roles: ["t_approver"],
      },
      {
        name: "",
        link: "/corporate/cpt-approver",
        icon: ApprovalRoundedIcon,
        tooltip: "CPT Approver",
        roles: ["cpt_approver"],
      },
      {
        name: "",
        link: "/corporate/audit-logs",
        icon: ArticleOutlinedIcon,
        tooltip: "Audit Logs",
        roles: ["system_admin"],
      },
      {
        name: "",
        link: "/corporate/help-center",
        icon: HelpCenterOutlined,
        tooltip: "Help Centre",
        roles: ["system_admin", "t_user", "t_approver", "cpt_approver"],
      },
    ],
  },
];
export const gaMenuModel: GaMenuItems[] = [
  {
    items: [
      {
        name: "",
        tooltip: "Dashboard",
        link: "/",
        icon: HomeOutlinedIcon,
      },

      {
        name: "",
        tooltip: "Temasek Corporate",
        link: "admin/corporate",
        icon: DomainAddIcon,
      },
      {
        name: "",
        tooltip: "Vendor Providers",
        link: "admin/vendor-providers",
        icon: GavelIcon,
      },
      {
        name: "",
        tooltip: "Payments",
        link: "admin/financials",
        icon: MonetizationOnIcon,
      },
      {
        name: "",
        tooltip: "RFPs Repository",
        link: "admin/all-rfp-list",
        icon: HowToRegIcon,
      },
    ],
  },
];
